import * as Styled from './styled'

interface IWarningPopupProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const WarningPopup = ({
  isOpen,
  onCancel,
  onConfirm
}: IWarningPopupProps) => {
  if (!isOpen) return null

  return (
    <Styled.Overlay className="prompt-to-video-modal-warning-popup">
      <Styled.PopupContainer>
        <Styled.Title>⚠️ Generation in Progress</Styled.Title>
        <Styled.Message>
          Your videos are still being generated. If you close now, you will lose
          all progress. Are you sure?
        </Styled.Message>
        <Styled.ButtonsWrapper>
          <Styled.CancelButton onClick={onCancel}>Cancel</Styled.CancelButton>
          <Styled.ConfirmButton onClick={onConfirm}>
            Close Anyway
          </Styled.ConfirmButton>
        </Styled.ButtonsWrapper>
      </Styled.PopupContainer>
    </Styled.Overlay>
  )
}
